import React from "react";

const TimerButton = ({
    quarterParams,
    time,
    timerSecondsSelected,
    setTimerSecondsSelected,
  }) => {
    const timeWithSecString = `${time}s`;
    const isSelected = timerSecondsSelected === time;
    return (
      <button
        style={{
          backgroundColor: isSelected ? "white" : "lightgray",
          borderRadius: "100%",
          height: 30,
          width: 30,
          border: "none",
          fontWeight: 600,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => {
          setTimerSecondsSelected(time);
        }}
      >
        {timeWithSecString}
      </button>
    );
};

export default TimerButton;